module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/ko_2-7409914b0bda452bcda606708e0e98be.jpg";